module.exports = __webpack_public_path__ + "img/a085a05.jpg";